import React from 'react';

const MapLicense = () => <p>Advoc8 Maps | © MapTiler © OpenStreetMap contributors</p>;

export default MapLicense;
